export const medicalHistoryTypes = {
  TYPE_ALLERGIES: 'TYPE_ALLERGIES'
};

export default { medicalHistoryTypes };
